import { useEffect } from 'react';
import { useAppStore } from '../store/useAppStore';
import type { Tip } from '../types';

export default function TipsPanel({ eventId }: { eventId: number }) {
  const { tips, loadTips } = useAppStore();
  const list = (tips[eventId] || []).slice().sort((a, b) => a.sortOrder - b.sortOrder);

  useEffect(() => {
    loadTips(eventId);
  }, [eventId, loadTips]);

  // 按阶段分组
  const phases = list.reduce((acc, tip) => {
    if (!acc[tip.phase]) acc[tip.phase] = [];
    acc[tip.phase].push(tip);
    return acc;
  }, {} as Record<string, Tip[]>);

  return (
    <div id="panel-tips" className="ac-card p-5">
      <div className="flex items-center gap-2 mb-4">
        <span className="text-2xl">📜</span>
        <h3 className="font-bold text-lg text-gray-800">锦囊妙计</h3>
        <span className="text-xs text-gray-400 ml-auto">注意事项 & 避坑指南</span>
      </div>

      {list.length === 0 ? (
        <p className="text-sm text-gray-400 text-center py-6">暂无妙计，可在群聊中请神仙支招</p>
      ) : (
        <div className="space-y-4">
          {Object.entries(phases).map(([phase, phaseTips]) => (
            <div key={phase}>
              <div className="flex items-center gap-2 mb-2">
                <span className="text-sm font-bold text-amber-600 bg-amber-50 px-3 py-1 rounded-full">
                  {phase}
                </span>
              </div>
              <div className="space-y-2 pl-2">
                {phaseTips.map((tip) => (
                  <div key={tip.id} className="p-3 rounded-xl bg-amber-50/50 border border-amber-100">
                    <div className="flex items-start gap-2">
                      <span className="text-base">💡</span>
                      <div>
                        <h4 className="font-medium text-sm text-gray-700 mb-1">{tip.title}</h4>
                        <p className="text-xs text-gray-500 leading-relaxed whitespace-pre-line">
                          {tip.content}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
